import { graphql } from "gql.tada";
import { LinkFragment } from "@queries/fragments/LinkFragment";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";
import { RichTextFragment } from "@queries/fragments/RichTextFragment";

export const SolutionsRowFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsRowFragment on SolutionsChapterRow {
      _id
      title
      eyebrow
      rowType
      collapsible
      ctaEvent
      ctaLink {
        ...LinkFragment
      }
      bodyRichText {
        ...RichTextFragment
      }
    }
  `,
  [LinkFragment, RichTextFragment]
);

export const SolutionsChapterFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsChapterFragment on SolutionsChapter {
      _id
      title
      eyebrow
      menuLabel
      ctaEvent
      ctaLink {
        ...LinkFragment
      }
      media {
        url
        contentType
      }
      mediaSourceRichText {
        ...RichTextFragment
      }
      mediaBodyRichText {
        ...RichTextFragment
      }
      mediaHeading
      mediaLayout
      iconGrid {
        ...IconGridFragment
      }
      rowsCollection(limit: 10) {
        items {
          ...SolutionsRowFragment
        }
      }
    }
  `,
  [SolutionsRowFragment, IconGridFragment, RichTextFragment, LinkFragment]
);

export const SolutionsSectionById = graphql(
  /* GraphQL */ `
    query SolutionsSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      solutionsSection(id: $id, preview: $preview, locale: $locale) {
        _id
        title
        chaptersCollection(limit: 6) {
          items {
            ...SolutionsChapterFragment
          }
        }
      }
    }
  `,
  [SolutionsChapterFragment]
);
